import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export function FilterGroup({ icon: Icon, title, children, defaultOpen = true, testId }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-[#3a1064]/15 last:border-b-0">
      <button
        type="button"
        data-testid={testId ? `${testId}-toggle` : undefined}
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 py-3 font-black text-[#3a1064] hover:bg-yellow-50 transition-colors"
      >
        {Icon && <Icon className="h-4 w-4 text-[#ff2bd6]" />}
        <span className="flex-1 text-left text-sm uppercase tracking-wider">{title}</span>
        {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
      </button>
      {open && (
        <div className="px-4 pb-3 space-y-1.5" data-testid={testId ? `${testId}-body` : undefined}>
          {children}
        </div>
      )}
    </div>
  );
}

export function FilterCheck({ checked, onChange, label, color, count, testId }) {
  return (
    <label
      data-testid={testId}
      className="flex items-center gap-2 cursor-pointer text-xs font-bold text-[#3a1064] hover:text-[#ff2bd6] select-none"
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 rounded border-2 border-[#3a1064] accent-[#ff2bd6] cursor-pointer"
      />
      {color && (
        <span
          className="h-3 w-3 rounded-full border-2 border-[#3a1064] shrink-0"
          style={{ background: color }}
        />
      )}
      <span className="flex-1 truncate">{label}</span>
      {typeof count === 'number' && (
        <span className="text-[10px] font-black text-[#3a1064]/60">{count}</span>
      )}
    </label>
  );
}
